__turbopack_context__.v({
  "className": "dancing_script_40c4c64f-module__K20EHq__className",
  "variable": "dancing_script_40c4c64f-module__K20EHq__variable",
});
